import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";

import {
  Container,
  Paper,
  Typography,
} from "@material-ui/core";


import { useStyles } from "./messgeraeteStyles";


import { globalStyles } from "../../../assets/globalStyles";

import { MessgeraeteGrid } from "./grid";
import { MessgeraeteEdit } from "./edit";
import { MessgeraeteActionheader } from "./actionheader";
import { useAppDispatch } from "../../../app/hooks";
import { getMessgeraete, getMessgeraettypen, getWartungsintervalle, getZSs } from "./messgeraeteSlice";
import { useMsal } from "@azure/msal-react";
import { useParams } from 'react-router';


export const Messgeraete: React.FC = () => {
  const dispatch = useAppDispatch();
  const { instance } = useMsal();

  const { id } = useParams<{id: string | undefined}>();

  useEffect(() => {
      dispatch(getMessgeraete(id));
      dispatch(getMessgeraettypen());
      dispatch(getZSs());
      dispatch(getWartungsintervalle());
  }, [instance]);

  const classes = {
    ...useStyles(),
    ...globalStyles(),
  };

  return (
    <React.Fragment>
      <Container maxWidth={false} style={{ marginTop: "10px" }}>
        <Grid container md={12} spacing={2} style={{ marginBottom: "10px" }}>
          <Grid item md={3} />
          <Grid item md={6}>
            <Typography color="primary" variant="h5">
              Verwaltung Messgeräte
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <MessgeraeteEdit />
      <Paper className={classes.paper} style={{ marginLeft: "24px", marginRight: "24px" }}>
        <MessgeraeteActionheader />
        <Grid container spacing={2} style={{ marginBottom: "20px" }}>
          <MessgeraeteGrid />
        </Grid>
      </Paper>
    </React.Fragment>
  );
}
